import React from "react"
import styles from "./Testimonials.module.css"
import SimpleSlider from "./SimpleSlider"
import FadeInSection from "../FadeInSection/FadeInSection"

const Testimonials = () => {
  return (
    <div className={styles.container} id="testimonials-page">
      <div className={styles.content}>
        <FadeInSection>
          <div className={styles.description}>
            <h1 className="bigTitleLight">What clients are saying </h1>
            <h2 className="smallTitleLight">
              Check out what customers are saying about us
            </h2>
            <div className="line"></div>
          </div>
          <SimpleSlider />
        </FadeInSection>
      </div>
    </div>
  )
}

export default Testimonials
